import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "segment scheme-light content" }
const _hoisted_2 = { class: "container-content" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-10-10 col-10-lg-2" }
const _hoisted_5 = { class: "facets" }
const _hoisted_6 = { class: "facet-reset" }
const _hoisted_7 = { class: "col-10-10 col-10-lg-8" }
const _hoisted_8 = { class: "publication-list inner-row" }
const _hoisted_9 = { class: "box-list-vertical" }
const _hoisted_10 = { class: "card card-box-list box-list-horizontal" }
const _hoisted_11 = { class: "card-title" }
const _hoisted_12 = ["href", "aria-label"]
const _hoisted_13 = { key: 1 }
const _hoisted_14 = {
  key: 0,
  class: "card-eyebrow card-eyebrow-category"
}
const _hoisted_15 = { class: "card-eyebrow" }
const _hoisted_16 = {
  key: 0,
  class: "pagination"
}

import { inject, nextTick, ref, Ref, watch } from 'vue';
import FacetsContainer from './components/FacetsContainer.vue';
import PaginationBar from './components/PaginationBar.vue';
import axios, { AxiosResponse } from 'axios';
import {
    parseSolrResponse,
    ParsedSolrResponseData,
    RequestUrl,
    SolrArguments,
    SolrResponseData, SolrJobDocument, SolrPublicationDocument
} from '../modules/solr'; // eslint-disable-line import/no-relative-parent-imports
import { breakpointsBootstrapV5, useBreakpoints } from '@vueuse/core';


export default /*#__PURE__*/_defineComponent({
  __name: 'PublicationList',
  props: {
    endpoint: {},
    pluginNamespace: {},
    arguments: {}
  },
  setup(__props: any) {

const props = __props;



const i18n = inject('i18n') as { [key: string]: string };
const defaultArguments: SolrArguments = {
    filter: ['type:tx_fwf_publications_domain_model_publication'], // fallback
    page: '1', // required
    perPage: '0', // placeholder, see setPerPage()
    q: '*', // required
    sort: 'title asc' // fallback
};

const userFacetFields = ['publicationCategory', 'publicationYear']; // array order defines display order
const initialArguments: SolrArguments = { ...defaultArguments, ...JSON.parse(props.arguments) as SolrArguments };

class PublicationsRequestUrl extends RequestUrl {
    public setPerPage (): void {
        let perPage = '4';
        if (largerThanMd.value) {
            perPage = '12';
        } else if (largerThanSm.value) {
            perPage = '8';
        }
        this.url.searchParams.set(`${props.pluginNamespace}[perPage]`, perPage);
    }
}
const publications: Ref<SolrPublicationDocument[]> = ref([]);
const initialUrl = PublicationsRequestUrl.buildFromArguments(props.endpoint, props.pluginNamespace, initialArguments) as PublicationsRequestUrl;
let currentUrl = PublicationsRequestUrl.buildFromArguments(props.endpoint, props.pluginNamespace, initialArguments) as PublicationsRequestUrl;

const breakpoints = useBreakpoints(breakpointsBootstrapV5);
const largerThanSm = breakpoints.greater('sm');
const largerThanMd = breakpoints.greater('md');

const currentSolrResponse = ref<ParsedSolrResponseData>({
    facets: [],
    documents: [],
    currentPageNumber: 1,
    totalNumberOfPages: 1
});

watch(publications, async () => {
    await nextTick();
    window.initCardWidgets();
});

function loadPublicationsAfterFacetChange (name: string, value: string, type: string): void {
    const url = new PublicationsRequestUrl(currentUrl);
    switch (type) {
        case 'add':
            url.addFilterParameter(`${name}:${value}`);
            break;
        case 'remove':
            url.removeFilterParameter(`${name}:${value}`);
            break;
        case 'set':
            url.removeFilter(name);
            url.addFilterParameter(`${name}:${value}`);
            break;
        default:
            // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
            console.trace(`Invalid change type '${type}' (facet change).`);
    }

    url.setPage(1);
    url.setPerPage();
    axios.get(url.toString()).then((response: AxiosResponse<SolrResponseData>) => {
        publications.value = response.data.documents as Array<SolrPublicationDocument>;
        currentSolrResponse.value = parseSolrResponse(response, userFacetFields);
        return undefined;
    }).catch(() => console.trace('Loading of publications failed (facet change).'));

    currentUrl = url;
}

function loadPublicationsAfterPageSelect (page: number): void {
    const url = new PublicationsRequestUrl(currentUrl);
    url.setPerPage();
    url.setPage(page);

    axios.get(url.toString()).then((response: AxiosResponse<SolrResponseData>) => {
        publications.value = response.data.documents as Array<SolrPublicationDocument>;
        currentSolrResponse.value = parseSolrResponse(response, userFacetFields);
        return undefined;
    }).catch(() => console.trace('Loading of publications failed (page select).'));

    currentUrl = url;
}

function loadInitialList (): Promise<void|undefined> {
    const url = PublicationsRequestUrl.buildFromArguments(props.endpoint, props.pluginNamespace, initialArguments) as PublicationsRequestUrl;
    url.setPerPage();
    currentUrl = url;
    return axios.get(url.toString()).then((response: AxiosResponse<SolrResponseData>) => {
        publications.value = response.data.documents as Array<SolrPublicationDocument>;
        currentSolrResponse.value = parseSolrResponse(response, userFacetFields);
        return undefined;
    });
}

function shortUrl (url: string): string {
    try {
        const shortUrl = new URL(url);
        return shortUrl.pathname.slice(1);
    } catch (e) {
        return url;
    }
}

function resetFilter (): void {
    loadInitialList().catch(() => console.trace('Loading of publications failed (filter reset).'));
}

loadInitialList().catch(() => console.trace('Initial loading of publications failed.'));


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(FacetsContainer, {
              facets: currentSolrResponse.value.facets,
              onChange: loadPublicationsAfterFacetChange
            }, null, 8 /* PROPS */, ["facets"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("button", {
              class: "button button-reset",
              onClick: resetFilter
            }, _toDisplayString(_unref(i18n).resetFilter), 1 /* TEXT */)
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createCommentVNode(" eslint-disable vuejs-accessibility/no-static-element-interactions "),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(publications.value, (document) => {
              return (_openBlock(), _createElementBlock("div", {
                key: document.id,
                class: _normalizeClass(['box-list box-list-top-closed box-grid box-grid-full-row col-2-2 publication-item', { 'pointer': document.url }])
              }, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("h3", null, [
                        (document.url)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              href: document.url,
                              target: "_blank",
                              "data-card-link": "href",
                              rel: "noopener noreferrer",
                              "aria-label": document.url && (document.url != document.publication) ? document.title + ' — ' + _unref(i18n).newWindowExternalUrlHint : document.title + ' — ' + _unref(i18n).newWindowHint
                            }, _toDisplayString(document.title), 9 /* TEXT, PROPS */, _hoisted_12))
                          : (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(document.title), 1 /* TEXT */))
                      ])
                    ]),
                    (document.subCategoryTitle)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(document.subCategoryTitle), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true),
                    _createElementVNode("div", _hoisted_15, [
                      (document.publicationAuthors && document.publicationDate)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(_toDisplayString(document.publicationAuthors) + " (" + _toDisplayString(new Date(document.publicationDate).getFullYear()) + "); ", 1 /* TEXT */)
                          ], 64 /* STABLE_FRAGMENT */))
                        : _createCommentVNode("v-if", true),
                      (document.url && (document.url != document.publication))
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode(" doi: " + _toDisplayString(shortUrl(document.url)) + "; ", 1 /* TEXT */)
                          ], 64 /* STABLE_FRAGMENT */))
                        : _createCommentVNode("v-if", true),
                      (document.publicationLanguageLabel)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                            _createTextVNode("  " + _toDisplayString(document.publicationLanguageLabel) + "; ", 1 /* TEXT */)
                          ], 64 /* STABLE_FRAGMENT */))
                        : _createCommentVNode("v-if", true),
                      (document.publicationFileExtension && document.publicationFileSize)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                            _createTextVNode("  " + _toDisplayString(document.publicationFileExtension) + " (" + _toDisplayString(document.publicationFileSize) + ") ", 1 /* TEXT */)
                          ], 64 /* STABLE_FRAGMENT */))
                        : _createCommentVNode("v-if", true)
                    ])
                  ])
                ])
              ], 2 /* CLASS */))
            }), 128 /* KEYED_FRAGMENT */))
          ]),
          (currentSolrResponse.value.totalNumberOfPages > 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _createVNode(PaginationBar, {
                  current: currentSolrResponse.value.currentPageNumber,
                  total: currentSolrResponse.value.totalNumberOfPages,
                  onSelect: loadPublicationsAfterPageSelect
                }, null, 8 /* PROPS */, ["current", "total"])
              ]))
            : _createCommentVNode("v-if", true)
        ])
      ])
    ])
  ]))
}
}

})